import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../../utils/utils";
import REInfoLastEmployeeDocBloc from "../../blocs/retirement/info-perso/REInfoLastEmployeeDocBloc";
import GeneralDataProtectionBloc from "../../blocs/common/GeneralDataProtectionBloc";


export default function REInfoLastEmployeeDocPage() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Justificatif du dernier employeur</h1>
       
        <div ref={pageGapRef} className="page-gap" />
        <div className="flex-grid m-lg-desktop bg-blanc p-lg shadow-noir">
            <REInfoLastEmployeeDocBloc />
        </div>
        <div className="m-lg-desktop">
          <GeneralDataProtectionBloc/> 
        </div>
      </div>
   
    )

}